/* istanbul ignore file */
// eslint-disable-next-line import/no-unassigned-import
import './data-dog-rum';

import React from 'react';
import { createRoot } from 'react-dom/client';
import Cookies from 'js-cookie';

import { App } from './App';
import { AppProvidersV2 } from 'mf_core/provider';

// eslint-disable-next-line import/no-unassigned-import
import type {} from '@im/im-theme/themeAugmentation';

import { ScrollToTop } from './ScrollToTop';

Cookies.set('IMOnline_CEP', 'true');

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(
  <AppProvidersV2 appId="cep" basename="/cep/app" envVars={process.env}>
    <ScrollToTop />
    <App />
  </AppProvidersV2>
);
